import React, { useEffect, useState } from 'react';
import GlobalMeta from '../reusable/GlobalMeta';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useVisible } from 'react-hooks-visible';
import { useMediaQuery } from '@mui/material';
import RiskwiseBanner from '../reusable/fieldGroups/RiskwiseBanner';
import Modules from '../reusable/modules';
import PartnersCarousel from '../reusable/PartnersCarousel';
import ImageBGSection from '../reusable/fieldGroups/ImageBGSection';
import RandomTestimonial from '../reusable/RandomTestimonial';
import Functions from '../reusable/Functions';
import ScrollingSection from '../reusable/fieldGroups/ScrollingSection';
import ColumnBoxes from '../reusable/fieldGroups/ColumnBoxes';
import { Box } from '@mui/system';
import HTMLComponents from '../reusable/htmlToReact';
import RiskwiseMenu from '../layout/RiskwiseMenu';


const Riskwise = ({ page }) => {

    const [container, container_visible] = useVisible((vi) => vi > 0.5);
    const mdDown = useMediaQuery(theme => theme.breakpoints.down('md'));
    const [playAnimation, setPlayAnimation] = useState(mdDown ? true : false);

    //get page
    const { data : riskwise, isInitialLoading } = useQuery({
        queryKey: ['home'],
        queryFn: () => axios({
            method: 'get',
            url: `${WP_API_Settings.endpoint}wp/v2/pages?slug=s2-riskwise-software&_embed=true&acf_format=standard`,
        })
    })

	//play once per page load
	useEffect(() => {
		if (container_visible && !playAnimation && page) {
			setPlayAnimation(true);
		}
	}, [container_visible, page]);

    console.log(riskwise);

    return (
        <>
            <GlobalMeta />
            <RiskwiseBanner banner={riskwise?.data?.[0].acf.riskwise_banner} loading={isInitialLoading} />
            <RiskwiseMenu />
            <HTMLComponents htmlComponents={riskwise?.data?.[0].content.rendered} loading={isInitialLoading}/>
            <Box id={'benefits'} />
            <ScrollingSection sections={riskwise?.data?.[0].acf.scrolling_section} loading={isInitialLoading} />
            <Box id={'modules'} />
            <Modules introData={riskwise?.data?.[0].acf.riskwise_modules} loading={isInitialLoading} />
            <Box id={'functions'} />
            <Functions functions={riskwise?.data?.[0].acf.functions} loading={isInitialLoading} />
            <Box id={'security-integrations'} />
            <ColumnBoxes columnBoxes={riskwise?.data?.[0].acf.column_boxes} loading={isInitialLoading} />
            <Box id={'testimonials'} />
            <RandomTestimonial testimonials={riskwise?.data?.[0].acf.testimonials} loading={isInitialLoading} />
            <PartnersCarousel loading={isInitialLoading} page={'riskwise'} />
            <ImageBGSection content={riskwise?.data?.[0].acf.image_background} loading={isInitialLoading} />
            <Box sx={{ height: '80px', width: '100%' }} />
        </>
    );
};

export default Riskwise;